import React from 'react';
import './portal.css';
import { PortalAuthProvider, usePortalAuth } from './PortalAuthContext';
import { PortalLoginScreen } from './PortalLoginScreen';
import { PortalChangePasswordScreen } from './PortalChangePasswordScreen';
import { PortalHome } from './PortalHome';

/**
 * Top-level component for the Service Provider portal.
 * Rendered when window.location.pathname starts with /portal.
 *
 * Wraps everything in <PortalAuthProvider> then routes between
 * login screen and authenticated views based on portal auth state.
 */
export function PortalApp() {
  return (
    <PortalAuthProvider>
      <PortalRoot />
    </PortalAuthProvider>
  );
}

function PortalRoot() {
  const { user, loading } = usePortalAuth();

  if (loading) {
    return (
      <div className="portal-loading">Loading…</div>
    );
  }

  if (!user) {
    return <PortalLoginScreen />;
  }

  // If she must change her password, force that flow before anything else.
  if (user.mustChangePassword) {
    return <PortalChangePasswordScreen />;
  }

  // Authenticated and password is set — show home.
  return <PortalHome />;
}


